
export const getCurrentCheckout = (state) => state.currentCheckout
export const getCurrentDeliveryInfo = (state) => state.currentDeliveryInfo
export const getOrderStatus = (state) => state.orderStatus
export const getReviewStatus = (state) => state.reviewStatus
export const getPendingOrdersCount = (state) => state.pendingOrdersCount
export const getCurrentProductPlaces = (state) => state.currentProductPlaces
